<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC000951')"
						:inputValue="searchParams.cpnyCd"
						:onChange="value => onChangSearchParam({ key: 'cpnyCd', value })"
					/>
				</el-col>
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC000957')"
						:inputValue="searchParams.partNo"
						:onChange="value => onChangSearchParam({ key: 'partNo', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => search()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		cpnyNum: { type: String, default: '' }
	},
	async created() {
		await this.search();
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		search() {
			this.$sf_toggleLoading(true);
			this.getPopupCpny_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChangSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
		},
		//사용자 정의 함수이며, key,value 값을 초기화 시켜줌
		reset() {
			this.setSearchParam_({ key: 'partNo', value: '' });
			this.setSearchParam_({ key: 'cpnyCd', value: '' });
		}
	}
};
</script>

<style></style>
